/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Options_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing to choose from." |
*
* @param {Spaces_Modular_Wizard_Options_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_options_empty = /** @type {((inputs?: Spaces_Modular_Wizard_Options_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Options_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Auswahl verfügbar.")
	return /** @type {LocalizedString} */ ("Nothing to choose from.")
});